/**
 * Shared enum representing the possible states of an upload job
 * 
 * This enum is used across multiple libraries to ensure consistency 
 * in job status representation.
 */
export enum JobStatus {
  PENDING = 'pending',
  STARTED = 'started',
  UPLOADING = 'uploading',
  PAUSED = 'paused',
  RESUMED = 'resumed',
  CANCELED = 'canceled',
  COMPLETE = 'complete',
  FAILED = 'failed',
}
